import { Flex, PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { ApplicationPageStepper, DocumentUploadSupportingContent } from "../../../components";
import { useDocumentQuery } from "../../../queries/document-uploads/queries";
import { useFundingApplication } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { CashFlowForecastDocumentUpload, DocumentNavigationGroup } from "../components";

export const CashFlowForecastDocumentUploadPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationData } = useFundingApplication(customerDomain);
  const { data: uploadedDocuments } = useDocumentQuery(customerDomain, fundingApplicationData.id);
  const hasUploadedDocuments = !!uploadedDocuments?.filter(
    (doc) => doc.documentType === UploadDocumentType.CASH_FLOW_FORECAST
  ).length;

  const CashFlowForecastDocumentUploadPrimary = (
    <Flex direction="column" gap="8">
      <CashFlowForecastDocumentUpload />
      <DocumentNavigationGroup
        isStepComplete={hasUploadedDocuments || fundingApplicationData.isCashflowForecastSkipped === true}
        forType={UploadDocumentType.CASH_FLOW_FORECAST}
      />
    </Flex>
  );

  return (
    <PrimarySecondaryPage
      titleSlot={<ApplicationPageStepper currentStepIndex={1} />}
      showStepperBackground={true}
      title={intl.formatMessage({
        id: "funding-application: revenue projections title",
        defaultMessage: "Upload your revenue projections",
      })}
      primaryContent={CashFlowForecastDocumentUploadPrimary}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
